const dedupeAndRemoveEscapeChar = (subscriptionNameList) => {
  subscriptionNameList = subscriptionNameList.reduce((unique, item) => {
    item = item && item.replace('&amp;', '&')
    return unique.includes(item) ? unique : [...unique, item]
  }, [])

  return subscriptionNameList
}

const setAndSortModalCategories = (categorySortOrder) => {
  // Hardcoded order for modal categories
  const defaultCategorySortList = [
    'Thought Leadership',
    'Author',
    'Topic',
    'Product Insights',
  ]

  // override it from the data attribute
  let categorySortList = defaultCategorySortList

  if (categorySortOrder) {
    categorySortList = this.dataset.categorySortOrder.split(',')
  }

  // so hack, such sadness
  // for blog category pages, really nowhere else to control the sort order
  if (window.location.href.indexOf('blog/category') >= 0) {
    categorySortList = [
      'Topic',
      'Thought Leadership',
      'Author',
      'Product Insights',
    ]
  }

  return categorySortList
}

export { dedupeAndRemoveEscapeChar, setAndSortModalCategories }
